import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { ToasterComponent } from 'src/app/shared/components/toaster/toaster.component';
import type { ActionToastComponent, ActionToastData } from 'src/app/shared/components/action-toast/action-toast.component';
@Injectable({
  providedIn: 'root'
})
export class ToasterService {

  constructor(public snackBar: MatSnackBar) { }

  /**
   * `title` overrides the heading, which otherwise reads "Success" or "Failed" off the type.
   *
   * Optional and last so every existing call keeps the heading it has. Worth overriding when the
   * outcome has a name of its own - "Draft Saved" tells the user what happened, where "Success"
   * only tells them it went well and leaves the message to carry the whole meaning.
   */
  showCustomSnackbar(message: string, type: 'success' | 'error', duration: number = 5000, title?: string) {

    const icon = type === 'success' ? 'circle-check-filled' : 'circle-x-filled';
    const color = type === 'success' ? 'icon-icon-success ' : 'icon-icon-error ';

    this.snackBar.openFromComponent(ToasterComponent, {
      data: { message, type, icon, color, duration, title },
      duration: duration,
      panelClass: ['custom-snackbar-container'],
      verticalPosition: 'bottom',
      horizontalPosition: 'right'
    });
  }

  /**
   * A toast with an optional inline action (e.g. Undo). Subscribe to the returned ref's
   * onAction() to run it. Pulled in lazily so the toast stays out of every chunk that
   * only uses showCustomSnackbar().
   */
  async showActionToast(data: ActionToastData, duration: number = 5000): Promise<MatSnackBarRef<ActionToastComponent>> {
    const { ActionToastComponent } = await import('src/app/shared/components/action-toast/action-toast.component');
    return this.snackBar.openFromComponent(ActionToastComponent, {
      data,
      duration,
      panelClass: ['action-toast-container'],
      verticalPosition: 'bottom',
      horizontalPosition: 'right'
    });
  }

}
